import React from "react";
import { ResponsiveBar } from "@nivo/bar";

const BarChart = ({data}: {data: any}) => {

    return(
        <ResponsiveBar
            data={data}
            keys={["value"]}
            indexBy={"day"}
            margin={{ top: 20, right: 10, bottom: 20, left: 40 }}
            padding={0.3}
            valueScale={{ type: "linear" }}
            indexScale={{ type: "band", round: true }}
            colors={{ scheme: "category10" }}
            borderColor={{ from: "color", modifiers: [ [ "darker", 1.6 ] ] }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 0,
                tickPadding: 5,
                tickRotation: 0,
                legend: null,
                legendPosition: "middle",
                legendOffset: 32
            }}
            axisLeft={{
                tickSize: 0,
                tickPadding: 10,
                tickRotation: 0,
                legend: null,
                legendPosition: "middle",
                legendOffset: -40
            }}
            enableLabel={false}
            enableGridY={false}
            legends={[]}
            animate={true}
            motionStiffness={90}
            motionDamping={15}
        />
    );
};

export default BarChart;